import { useContext } from 'react';
import { PersistentNotificationsContext } from './PersistentNotificationsContext';

/**
 * A hook to retrieve persistent notifications.
 */
export const usePersistentNotifications = () => {
  const persistentNotifications = useContext(PersistentNotificationsContext);

  return persistentNotifications;
};
